import React from 'react';
import { Building2, ChevronDown, User } from 'lucide-react';
import { useCustomerType } from '../context/CustomerTypeContext';

interface CustomerTypeSwitcherProps {
  onClick?: () => void;
  compact?: boolean;
  className?: string;
}

const CustomerTypeSwitcher: React.FC<CustomerTypeSwitcherProps> = ({
  onClick,
  compact = false,
  className = ''
}) => {
  const { customerType } = useCustomerType();
  const isBusiness = customerType === 'business';

  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center gap-2 rounded-xl border border-slate-700 bg-slate-900/70 hover:bg-slate-800/80 text-slate-100 transition-colors ${compact ? 'px-2.5 py-1.5 text-xs' : 'px-3 py-2 text-sm'} ${className}`}
      aria-label="Byt mellan privatperson och företag"
      title="Byt mellan privatperson och företag"
    >
      <span className={`inline-flex items-center justify-center rounded-none ${compact ? 'w-6 h-6' : 'w-7 h-7'} ${isBusiness ? 'bg-blue-500/15 text-blue-200' : 'bg-purple-500/15 text-purple-200'}`}>
        {isBusiness ? <Building2 size={compact ? 14 : 16} /> : <User size={compact ? 14 : 16} />}
      </span>
      <span className={`font-medium ${compact ? 'hidden' : 'inline'}`}>
        {isBusiness ? 'Företag' : 'Privatperson'}
      </span>
      <ChevronDown size={compact ? 14 : 16} className="text-slate-400" />
    </button>
  );
};

export default CustomerTypeSwitcher;

